import { EXPENSE_TYPE_ERROR,EXPENSE_TYPE_SUCCESS,EDIT_EXPENSE_TYPE } from './actionTypes';

const initialState = {
    error: "",
    success : ""
}

const ExpenseType = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_EXPENSE_TYPE:
            state = { ...state }
            break;
        case EXPENSE_TYPE_SUCCESS:
            state = { ...state, success: action.payload }
            break;
        case EXPENSE_TYPE_ERROR:
            state = { ...state, error: action.payload };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default ExpenseType;